var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    stroke: "black",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5166 2.19043C9.41328 2.19043 6.89551 4.51318 6.89551 7.37396C6.89551 10.6657 10.6429 15.8821 12.0189 17.6839C12.076 17.7599 12.1509 17.8218 12.2373 17.8645C12.3238 17.9072 12.4195 17.9294 12.5166 17.9294C12.6136 17.9294 12.7093 17.9072 12.7958 17.8645C12.8823 17.8218 12.9572 17.7599 13.0143 17.6839C14.3903 15.8829 18.1376 10.6683 18.1376 7.37396C18.1376 4.51318 15.6199 2.19043 12.5166 2.19043Z",
    stroke: "inherit",
    strokeWidth: 1.47538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3082 9.64444C13.4352 9.64444 14.3488 8.73083 14.3488 7.60384C14.3488 6.47684 13.4352 5.56323 12.3082 5.56323C11.1812 5.56323 10.2676 6.47684 10.2676 7.60384C10.2676 8.73083 11.1812 9.64444 12.3082 9.64444Z",
    stroke: "inherit",
    strokeWidth: 1.47538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOutline);
export default __webpack_public_path__ + "static/media/location-outline.b7e5f981bcc59e4cd9fc0413d2d9b2f5.svg";
export { ForwardRef as ReactComponent };